import { Trans } from "@lingui/macro";
import { Menu, MenuItem, ListItemIcon } from "@mui/material";
import {
  WfButton,
  WfIconContentAddRegular,
  WfIconContentArrowArcLeftRegular,
  WfIconNavigationOverflowRegular,
} from "@WahooFitness/redesignr";
import { MouseEvent, useCallback, useState } from "react";
import AddCustomPageDrawer from "./Drawers/AddCustomPageDrawer";
import ResetPagesDrawer from "./Drawers/ResetPagesDrawer";
import { useDrawerContext } from "@WahooFitness/wahoo-offline-mfe";

function WorkoutPagesActionMenu({
  maxPageNameLength,
  resetPagesToDefault,
  addCustomPage,
}: {
  maxPageNameLength: number;
  resetPagesToDefault: () => void;
  addCustomPage: (name: string) => void;
}) {
  const { handleClose: handleCloseDrawer } = useDrawerContext();

  const [newPageName, setNewPageName] = useState("");

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);
  const handleMenuOpen = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);
  const handleMenuClose = useCallback(() => setAnchorEl(null), []);

  const [addPageDrawerOpen, setAddPageDrawerOpen] = useState(false);
  const [resetPageDrawerOpen, setResetPageDrawerOpen] = useState(false);

  const handleAddPage = useCallback(() => {
    handleMenuClose();
    setAddPageDrawerOpen(true);
  }, [handleMenuClose]);

  const handleCloseAddPageDrawer = useCallback(() => {
    setNewPageName("");
    setAddPageDrawerOpen(false);
    handleCloseDrawer();
  }, [handleCloseDrawer]);

  const handleResetPages = useCallback(() => {
    handleMenuClose();
    setResetPageDrawerOpen(true);
  }, [handleMenuClose]);

  return (
    <>
      <WfButton
        hierarchy="text"
        iconOnly
        id="basic-button"
        onClick={handleMenuOpen}
        aria-label="workout pages menu"
      >
        <WfIconNavigationOverflowRegular />
      </WfButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        MenuListProps={{ "aria-labelledby": "basic-button" }}
      >
        <MenuItem onClick={handleAddPage}>
          <ListItemIcon>
            <WfIconContentAddRegular color="primary" />
          </ListItemIcon>
          <Trans>Add page</Trans>
        </MenuItem>
        <MenuItem onClick={handleResetPages}>
          <ListItemIcon>
            <WfIconContentArrowArcLeftRegular color="primary" />
          </ListItemIcon>
          <Trans>Reset to default</Trans>
        </MenuItem>
      </Menu>

      <AddCustomPageDrawer
        open={addPageDrawerOpen}
        pageName={newPageName}
        handleOnChange={(value) => setNewPageName(value)}
        handleSave={() => {
          addCustomPage(newPageName);
          setNewPageName("");
          handleCloseAddPageDrawer();
        }}
        handleCancel={handleCloseAddPageDrawer}
        maxPageNameLength={maxPageNameLength}
      />

      <ResetPagesDrawer
        handleCloseDrawer={() => {
          handleCloseDrawer();
          setResetPageDrawerOpen(false);
        }}
        handleReset={async () => {
          await resetPagesToDefault();
          handleCloseDrawer();
          setResetPageDrawerOpen(false);
        }}
        open={resetPageDrawerOpen}
      />
    </>
  );
}
export default WorkoutPagesActionMenu;
